import { useToast as useChakraToast, UseToastOptions } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';

export interface Options extends UseToastOptions {
  titleParams?: string[];
  descriptionParams?: string[];
}

export const useToast = ({
  title,
  titleParams,
  description,
  descriptionParams,
  ...props
}: Options) => {
  const translate = useTranslate();

  const staticTitle = translate(title, titleParams);
  const staticDescription = translate(description, descriptionParams);
  const toast = useChakraToast({
    ...props,
  });
  return ({
    title,
    titleParams,
    description,
    descriptionParams,
    ...props
  }: Options) =>
    toast({
      title: title ? translate(title, titleParams) : staticTitle,
      description: description
        ? translate(description, descriptionParams)
        : staticDescription,
      ...props,
    });
};
